(ns teamoesterreich.user-mode.prevent.prevent-location
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.fb-questionnaire-helper :as fb-q-helper]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.ui-helper.stars :as stars]
    ))


(defn card [locationId isMain]
  (let [
        !publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)

        !location (r/cursor store/app-state [:locations locationId])
        !selected-location (r/cursor store/app-state [:state :selected-location])
        location @!location
        lat (and (get-in location [:coordinates]) (.-_lat ^js (get-in location [:coordinates])))
        lng (and (get-in location [:coordinates]) (.-_long ^js (get-in location [:coordinates])))
        preparation-enabled (:preparation-enabled location)
        questionnaires-cs (r/cursor store/app-state [:questionnaires])
        !selected-questionnaire (r/cursor store/app-state [:state :selected-questionnaire])
        location-questionnaires (into {} (filter (fn [[uuid q]] (and preparation-enabled
                                                                     (:appearance-location q)
                                                                     (:active q)
                                                                     (if show-unpublished? true (:published q))
                                                                     ))
                                                 @questionnaires-cs))]

    [mui/card
     {:style {:marginTop "5px" :marginBottom "15px"
              }}
     [mui/card-content
      {:style {:display "flex" :flexDirection "row"}}
      [mui/card-media
       {:component "img"
        :style     {:flex "0 1 400px"}
        :image     (or (:location-picture-path-fst location)
                       (and lat lng
                            (str "https://maps.googleapis.com/maps/api/staticmap?"
                                 "center=" lat "," lng "&zoom=14&size=400x300&"
                                 "markers=color:red|" lat "," lng
                                 "&key=" config/GOOGLE_MAPS_API "&"
                                 ))
                       "/custom/img/home.png")
        :width     "300"
        :height    "200"
        :onClick   (fn []
                     (reset! !selected-location locationId)
                     (a/set-page :prevent-locationView))
        :title     (str (get-in location [:name]))
        :alt       (str (get-in location [:name]))
        }]


      [mui/card-content
       {:style {:flex "1 0 auto"}}
       [mui/typography {:variant "h5" :component "h5"}
        (str (get-in location [:name]))]
       [:br]
       (when isMain
         [mui/typography {:variant "h5" :component "h5" :color "primary"} "Wohnadresse"])
       [:br]
       [mui/typography {:variant "body2" :component "p" :color "textSecondary"}
        (str (get-in location [:address]))]
       [:br]
       [:div
        (stars/five-stars (fb-q-helper/get-location-stars locationId))
        ]]
      ]
     [mui/card-content
      {:style {:textAlign "center"}}

      [mui/list {:component "nav" :aria-label "location questionnaires" :style {:margin "0 10px 0 10px"}}
       (for [[uuid q] location-questionnaires]
         (let [onClick-fn (fn []
                            (reset! !selected-questionnaire uuid)
                            (reset! !selected-location locationId)
                            (a/set-page :questionnaire-location-intro))]
           ^{:key (str "location-questionnaires-" uuid)} [mui/list-item {:key     (str "questionnaire" (:name q))
                                                                         :button  true
                                                                         :onClick onClick-fn}
                                                          [mui/list-item-text {:primary (str (:name q) (when-not (:published q) " - [unveröffentlicht]"))}]
                                                          [mui/list-item-secondary-action {:edge "end" :aria-label "goto" :onClick onClick-fn} [mui/icon-button [keyboard-arrow-right]]]
                                                          ]
           ))
       ]

      ]]

    ))